<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('chat-bots') }} -> {{ $t('create-group-manager') }}
    </h1>
    <div class="main__body">
      <p class="gray-about">{{ $t('create-group-manager-about-1') }} <br> {{ $t('create-group-manager-about-2') }}</p>
      <label class="label">{{ $t('all-authorized-users') }}</label>
      <div class="input-search">
        <input class="search large" :placeholder="$t('enter-users-surname')" v-model="search" v-on:keyup.enter="getClients()"/>
        <img src="@/assets/icon/search.svg">
      </div>
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col"></th>
          <th scope="col">{{ $t('name') }}</th>
          <th scope="col">{{ $t('surname') }}</th>
          <th scope="col">Telegram_nickname</th>
        </tr>
        </thead>
        <tbody v-if="clients.length > 0">
        <tr v-for="(item, index) in clients" v-bind:key="item.id">
          <th scope="row" class="small-first-th">
            {{ index + 1}}
          </th>
          <th scope="row">
            <label class="table__selected">
              <input type="checkbox" v-model="group.checkedClient" :value="item.id">
              <span class="checkmark"></span>
            </label>
          </th>
          <td class="pointer" v-on:click.self="showClientModal(item.id)">{{ item.firstname ? item.firstname : '' }}</td>
          <td>{{ item.middlename ? item.middlename : '' }}</td>
          <td>{{ item.username ? item.username : '' }}</td>
        </tr>
        </tbody>
        <div class="tbody-empty" v-else>
          <p>Ничего не найдено</p>
        </div>
      </table>
      <div class="form-row justify-content-center" v-if="clients.length < cClient && search === null || search === ''">
        <a class="btn" @click="nextPage">{{ $t('show-more') }}</a>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>{{ $t('group-name') }}</label>
          <input class="large" type="text" :placeholder="$t('group-name')" v-model="group.name">
          <span class="error" v-if="errors.name">{{ errors.name[0] }}</span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>{{ $t('chat-bot-branch') }}</label>
          <select class="custom-select large" :placeholder="$t('chat-bot-branch')" v-model="group.selectedBranch">
            <option value="" :selected="true">{{ $t('select-branch') }}</option>
            <option v-for="item in branch" v-bind:key="item.id" :value="item.id">{{ item.bot_type }} - {{ item.name }}</option>
          </select>
          <span class="error" v-if="errors.request_id">{{ errors.request_id[0] }}</span>
        </div>
      </div>
      <div class="form-row mt-1">
        <button type="submit" class="btn btn-primary" @click="createGroup">{{ $t('create-new-group-managers') }}</button>
      </div>
    </div>
    <clientModal :id="selectUser" v-show="isModalClientVisible"
                 @close="closeClientModal"/>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import clientModal from "../components/modal/clientModal";
export default {
  name: 'create-group-manager',
  data: function(){
    return{
      group: {
        name: null,
        checkedClient: [],
        selectedBranch: '',
      },
      selectUser: 0,
      isModalClientVisible: false,
      search: null,
      dynamicSearch: {
        searchVarChar: {},
        searchDouble: {},
        searchDate: {},
      },
      clients: [],
      cClient: 0,
      page: 1,
      branch: [],
      errors: [],
      isLoading: false,
      fullPage: true
    }
  },
  created: function(){
    this.getClients();
    this.getBranchBot();
  },
  methods: {
    showClientModal(id) {
      this.selectUser = id;
      this.isModalClientVisible = true;
    },
    closeClientModal() {
      this.isModalClientVisible = false;
    },
    nextPage: function(){
      this.page++;
      this.getClients();
    },
    getClients: function(){
      this.isLoading = true;
      var data = {
        segment_id: '',
        search: this.search,
        dynamicSearch: this.dynamicSearch,
        page: this.page
      }
      axios.post('getClients', data).then(response => {
        var status = response.data.status;
        if(status){
          this.clients = response.data.clients;
          this.cClient = response.data.cClient;
          this.isLoading = false;
        }
      });
    },
    getBranchBot: function(){
      axios.post('getBranchBots').then(response => {
        var status = response.data.status;
        if(status){
          this.branch = response.data.branch;
          this.isLoading = false;
        }
      });
    },
    createGroup: function(){
      axios.post('createGroupManager', this.group).then(response => {
        var status = response.data.status;
        if(status){
          this.group.name = '';
          this.group.checkedClient = [];
          this.group.selectedBranch = '';
          this.errors = [];
          this.isLoading = false;
          this.$toast.success('Группа успешно создана');
        }else{
          this.errors = response.data.errors;
          if(response.data.error){
            this.$toast.error(response.data.error);
          }
        }
      });
    },
  },
  components: {
    loading, clientModal
  }
}
</script>